// src/components/ModuleGraphCard.js
import React from 'react';

const ModuleGraphCard = ({
  totalQuestions = 0,
  mastered = 0,
  inProgress = 0,
  remaining = 0,
}) => {
  const total = mastered + inProgress + remaining || 1;
  const pct = (value) => Math.round((value / total) * 100);

  const rows = [
    { label: 'Mastered', value: mastered, color: 'bg-emerald-500' },
    { label: 'Needs Review', value: inProgress, color: 'bg-amber-400' },
    { label: 'Not Started', value: remaining, color: 'bg-gray-300' },
  ];

  return (
    <div className="w-full h-full bg-white rounded-md p-4 flex flex-col justify-between">
      <div>
        <h2 className="text-sm font-semibold text-gray-800 mb-1">
          Mastery Breakdown
        </h2>
        <p className="text-xs text-gray-500 mb-4">
          {totalQuestions} Questions In This Module
        </p>

        {rows.map((row) => (
          <div key={row.label} className="mb-3 last:mb-0">
            <div className="flex justify-between text-[11px] text-gray-600 mb-1">
              <span>{row.label}</span>
              <span>{pct(row.value)}%</span>
            </div>
            <div className="w-full h-2 rounded-full bg-gray-100 overflow-hidden">
              <div
                className={`h-2 ${row.color} rounded-full transition-all`}
                style={{ width: `${pct(row.value)}%` }}
              />
            </div>
          </div>
        ))}
      </div>

      <div className="mt-4 pt-3 border-t border-gray-100 text-[11px] text-gray-500">
        <span className="font-semibold text-emerald-600">
          {pct(mastered)}% mastered
        </span>{' '}
        {pct(mastered) === 100
          ? "· You’ve fully mastered this module. Great job!"
          : "· Keep going to reach full mastery."
        }
      </div>
    </div>
  );
};

export default ModuleGraphCard;
